import React from 'react';
import ImageUploader from 'react-images-upload';

const ImageUploaderComponent = (props) => {

    const {
      onImageUploaded
    } = props;

    const onChange = (file) => {
        let reader = new FileReader();
        reader.readAsDataURL(file[0]);
        reader.onloadend = () => {
          onImageUploaded(reader.result);
        };
      }

    return (<div>
        <ImageUploader
          {...props}
          withIcon={true}
          singleImage={true}
          buttonText='Choose images'
          imgExtension={['.jpg', '.jpeg', '.png']}
          maxFileSize={5242880}
          onChange={onChange}
        />
    </div>);
}

export default ImageUploaderComponent;